import React, { useEffect } from 'react';
import styled from 'styled-components'
import NavBar from '../Components/NavBar';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import { useState } from 'react';
import Footer from '../Components/Footer';
import PushCards from '../Components/PushCards';
import MobileNav from '../Components/MobileNav';


const HELP = styled.article`
@media screen and (max-width: 48rem) {
display: flex;
justify-content: center;
align-items: center;
flex-flow: column;
& h3 {
    color: blueviolet;
}
& h3 span {
margin-left: 1rem;
}
}

@media screen and (min-width: 48rem) {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-flow: column;
    & h3 {
        color: blueviolet;
       cursor: pointer;

    }
    & h3 span {
    margin-left: 1rem;
    }
}

`
const CONTENT = styled.section`
     border-left-width: .2rem;
    border-left-color: #8787e8;
    border-left-style: groove;
    margin-left: .2rem;
    @media screen and (min-width: 48rem) {
        max-width: 50%
      
    }
    
    `
const Faqs = () => {
    const [cont, setCon] = useState('pay')
    useEffect(() => {document.title = 'Help Center'; alert('This page is still undergoing production, pls email us at wealthmeservices@gmail.com, thank you.')}, [])
    return ( 
        <>
<NavBar />     
<PushCards />
<MobileNav />
   <h1 style={{textAlign:'center', paddingTop:'10rem', marginBottom: '2rem'}}>FAQ's</h1>

<HELP>
<h3 onClick={() => setCon('how')}><HelpOutlineIcon style={{fontSize:'3rem', verticalAlign:'sub'}} /><span style={{verticalAlign:'super'}}>How Do I Use Iamwealthy</span></h3>
<CONTENT style={cont ==='how' ? {display: 'block'} : {display:'none'}}>
    <ol style={{listStyleType:'none'}}>
        <li style={{lineHeight:'2.5rem'}}><strong>Static Use: </strong> Iamwealthy has no access to your Bank Account in any way for now, we work only with the information's of your expenses you give to us.
        After setting up your financial structure you can begin using the App by telling us of your current account balance
        <img src={require('../Assets/Images/fin2.jpg')} style={{width:'100%', height:'20%' }} alt='Static use method' />
        After then we help you divide this balance correspondingly and as you spend and recieve money per time on a specific purpose you record it at your wall
        <h3>Recieve</h3>
        <img src={require('../Assets/Images/fin2.jpg')} style={{width:'100%', height:'20%' }} alt='Static use method' />
        <h3>Spend</h3>
        <img src={require('../Assets/Images/fin2.jpg')} style={{width:'100%', height:'20%' }} alt='Static use method' />
        <h3>Recive on Specific Budget</h3>
        <img src={require('../Assets/Images/fin2.jpg')} style={{width:'100%', height:'20%' }} alt='Static use method' />
        </li>
        <li style={{lineHeight:'2.5rem',marginTop:'3rem'}}><strong>Dynamic Use: </strong> The application can also be used Dynamically. Using it in this way, you only need to setup your Financial structure and as you spend and recive money on a Daily basis you record it. 
        The difference here is that you dont record initialy your current account balance but your present(now) daily expenses and transactions
        <img src={require('../Assets/Images/fin2.jpg')} style={{width:'100%', height:'20%' }} alt='Static use method' />
        </li>
     </ol>
</CONTENT>


<h3 onClick={() => setCon('log')}><HelpOutlineIcon style={{fontSize:'3rem', verticalAlign:'sub'}} /><span style={{verticalAlign:'super'}}>Why Am I Always Logged Out</span></h3>
<CONTENT style={cont ==='log' ? {display: 'block'} : {display:'none'}}>
<ol style={{listStyleType:'none'}}>
        <li style={{lineHeight:'2.5rem'}}><strong>Authentificaion: </strong> Our Application uphold's our users data security as a top priority, hence, every time you close the application we automatically log you even if you dont manually use the log out button at the navigation bar.
        We also advise you use the log out button every time you are done using the application
        <img src={require('../Assets/Images/fin2.jpg')} style={{width:'100%', height:'20%' }} alt='Authentificaion' />

        </li>
        </ol>

</CONTENT>


<h3 onClick={() => setCon('pay')}><HelpOutlineIcon style={{fontSize:'3rem', verticalAlign:'sub'}} /><span style={{verticalAlign:'super'}}>How Often Do I Pay</span></h3>
<CONTENT style={cont ==='pay' ? {display: 'block'} : {display:'none'}}>
<ol style={{listStyleType:'none'}}>
        <li style={{lineHeight:'2.5rem'}}><strong>Payment System: </strong> Iamwealthy charge's her user's a monthly fee of NGN300 for the Private plan and NGN700 for the Beautifull plan which comes with Artificial Intelligence. This money is NOT automaticaly deducted from you Bank account, but you pay monthly manually
        <img src={require('../Assets/Images/planA.jpg')} style={{width:'100%', height:'20%' }} alt='Authentificaion' />
        <img src={require('../Assets/Images/planB.jpg')} style={{width:'100%', height:'20%' }} alt='Authentificaion' />
        </li>
        </ol>
        </CONTENT>

<h3 onClick={() => setCon('wall')}><HelpOutlineIcon style={{fontSize:'3rem', verticalAlign:'sub'}} /><span style={{verticalAlign:'super'}}>Meaning Of The Graphs And Labels</span></h3>
<CONTENT style={cont ==='wall' ? {display: 'block'} : {display:'none'}}>
<ol style={{listStyleType:'none'}}>
        <li style={{lineHeight:'2.5rem'}}><strong>Graphs {'&'} Labels: </strong>  
        <h4>Graphs</h4>
        <img src={require('../Assets/Images/fin2.jpg')} style={{width:'100%', height:'20%' }} alt='Authentificaion' />
        The Graph pictorially present the money spent and recieved
        on each of your Budget
        <h4>Report</h4>
        The Report give's you an inspired or motivated statement based on how much you spent or recived for the month, week or day
        <img src={require('../Assets/Images/fin2.jpg')} style={{width:'100%', height:'20%' }} alt='Authentificaion' />
        <h4>Balance</h4>
        The balance is the total money left for each of your budget after a money is spent or recieved
        <img src={require('../Assets/Images/fin2.jpg')} style={{width:'100%', height:'20%' }} alt='Authentificaion' />
        <h4>Diff</h4>
         DIFF is the difference between your last balance and the money deducted or recived on a particular budget
        <img src={require('../Assets/Images/fin2.jpg')} style={{width:'100%', height:'20%' }} alt='Authentificaion' />
        <h4>Spent / Recived</h4>
         SPENT / RECIEVED is the total money spent or recieved for a particular day, week or month
        <img src={require('../Assets/Images/fin2.jpg')} style={{width:'100%', height:'20%' }} alt='Authentificaion' />

        </li>
        </ol>
        </CONTENT>


        <h3 onClick={() => setCon('pur')}><HelpOutlineIcon style={{fontSize:'3rem', verticalAlign:'sub'}} /><span style={{verticalAlign:'super'}}>Must I write A Purpose</span></h3>
        <CONTENT style={cont ==='pur' ? {display: 'block'} : {display:'none'}}>
        <ol style={{listStyleType:'none'}}>
        <li style={{lineHeight:'2.5rem'}}><strong>Purpose: </strong> 
        We recommend you write a purpose for each transaction(money spent or recived recorded). This helps you making decisions in the future because you will be able to trace budgets or things responsible for much lost in your finance's.
        And it also help's our AI's assist you in the decision making process.
        <img src={require('../Assets/Images/fin2.jpg')} style={{width:'100%', height:'20%' }} alt='Purpose for the transaction' />
        </li>
        </ol>
        </CONTENT>

        <h3 onClick={() => setCon('quo')}><HelpOutlineIcon style={{fontSize:'3rem', verticalAlign:'sub'}} /><span style={{verticalAlign:'super'}}>How Quote Reminder Works</span></h3>
        <CONTENT style={cont ==='quo' ? {display: 'block'} : {display:'none'}}>
        <ol style={{listStyleType:'none'}}>
        <li style={{lineHeight:'2.5rem'}}><strong>Quote Reminder: </strong> After you fill and save your quotes and top financial commitments
        <img src={require('../Assets/Images/fin2.jpg')} style={{width:'100%', height:'20%' }} alt='Purpose for the transaction' />
        You can always access them everytime you log in by clicking the brown right button and closing them by clicking it again.
        This way Iamwealthy keeps her user's always motivated and focused on their finances'
        <h4>Change Quotes {'&'} Commitment</h4>
        At the bottom of the page you can click the Quotes Link
        <img src={require('../Assets/Images/fin2.jpg')} style={{width:'100%', height:'20%' }} alt='Quotes Link' />
        Pls note changing your quotes or commitments will erase every other you previously had
        </li>
        </ol>
        </CONTENT>
</HELP>
        
        <Footer />
        </>
     );
}
 
export default Faqs;